// Thin GA4 wrapper + best-effort funnel beacon to our backend (anonymous, no PII).
const FUNNEL = new Set(["hero_cta", "experience_view", "scene_reached", "demo_launched", "subscribe_click", "book_demo", "signup_complete"]);

function sid() {
  try {
    let s = localStorage.getItem("ari_sid");
    if (!s) { s = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`; localStorage.setItem("ari_sid", s); }
    return s;
  } catch (_) { return "anon"; }
}

export function track(event, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") window.gtag("event", event, params);
  } catch (_) { /* analytics must never break the app */ }
  try {
    if (FUNNEL.has(event) && typeof window !== "undefined") {
      const url = (typeof process !== "undefined" && process.env.REACT_APP_BACKEND_URL) || "";
      if (url) fetch(`${url}/api/public/track`, {
        method: "POST", headers: { "Content-Type": "application/json" }, keepalive: true,
        body: JSON.stringify({ event, session: sid(), path: window.location.pathname, lang: (localStorage.getItem("si_lang") || "en"), meta: params }),
      }).catch(() => {});
    }
  } catch (_) { /* noop */ }
}

export function reportClientError(message, stack) {
  try {
    const url = (typeof process !== "undefined" && process.env.REACT_APP_BACKEND_URL) || "";
    if (!url) return;
    fetch(`${url}/api/client-errors`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message: String(message || "").slice(0, 500), stack: String(stack || "").slice(0, 4000), url: window.location.pathname }),
      keepalive: true,
    }).catch(() => {});
    track("exception", { description: String(message || "").slice(0, 150), fatal: true });
  } catch (_) { /* noop */ }
}
